import type { Data } from '@/api/api.ts'
import type { ClientPhoneNumberRequestData, LoginRequestData } from '@/types/authentication.types'
import type { ExtendedAuthPhoneNumberRequestData } from '@/types/complaints.types'
import axios from 'axios'
import { baseUrl } from '@/constants/api'

const urlPrefix = `${baseUrl}complaint/incoming-call/`

export const getPhoneDst = async (country: string, id: string): Promise<Data<ExtendedAuthPhoneNumberRequestData>> => {
  return axios.get(`${urlPrefix}phonedst/`, {
    params: { country, session: id },
  })
}

export const checkStatus = async (country: string, id: string): Promise<Data<ClientPhoneNumberRequestData>> => {
  return axios.get(`${urlPrefix}phonesrc/`, { params: { country, session: id } })
}

export const callBlocking = async (country: string, id: string): Promise<Data<LoginRequestData>> => {
  return axios.post(`${urlPrefix}call-blocking/`, { country }, { params: { session: id } })
}
